module.exports = __webpack_public_path__ + "img/button_close.fb9cde36.svg";